module.exports = __webpack_public_path__ + "static/media/trimmedSkin.c4a98ca1.png";